import { gql } from 'graphql-request'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Trash2 } from 'lucide-react'

import { useMutation } from '@hooks/graphql'
import { useFlashMessage } from '@components/FlashMessage'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@components/ui/dialog'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

const DELETE_PROJECT_MUTATION = gql`
  mutation deleteEducatorProject($input: DeleteEducatorProjectInput!) {
    deleteEducatorProject(input: $input) {
      success
      errors {
        message
      }
    }
  }
`

const DeleteProjectDialog = ({
  closeModal,
  isOpen,
  projectId,
  name,
  assignedToClassrooms,
  refetch
}) => {
  const { setFlashMessage } = useFlashMessage()

  const { mutate: deleteProject, isLoading: isDeleting } = useMutation({
    gqlMutation: DELETE_PROJECT_MUTATION,
    variables: { input: { id: projectId } },
    onSuccess: () => {
      setFlashMessage('Project deleted', 'success')
      closeModal()
      refetch()
    }
  })

  return (
    <Dialog open={isOpen} onOpenChange={closeModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete lesson</DialogTitle>
          <DialogDescription className='mb-3'>
            You're about to delete <strong>{name}</strong>.
          </DialogDescription>
        </DialogHeader>

        <If condition={assignedToClassrooms}>
          <Alert variant="destructive" className='mb-3'>
            <ExclamationTriangleIcon className='h-5 w-5' />
            <AlertTitle>Warning</AlertTitle>
            <AlertDescription>
              This will remove the lesson from classrooms it's assigned to
            </AlertDescription>
          </Alert>
        </If>

        <DialogFooter>
          <Button
            onClick={() => deleteProject()}
            disabled={isDeleting}
            variant='destructive'
            className='w-fit mt-3 self-end'
          >
            <Trash2 className='mr-2 h-4 w-4' />
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteProjectDialog 
